export default __webpack_public_path__ + "static/media/postSuvinil7.65ab2066.png";